import {chunk} from 'lodash';
import delay from 'delay';
import {getCharLength} from '@/lib/helper';

export const pageConfig = {
    feed: {
        title: '信息流广告标题',
        type: 'FEED_TITLE'
    },
    fc: {
        title: '搜索广告创意文案',
        type: 'FC_TITLE'
    },
    script: {
        title: '口播文案',
        type: 'MOUTH_SCRIPT'
    },
    feedRewrite: {
        title: '信息流广告优化',
        type: 'FEED_TITLE_REWRITE'
    },
    fcRewrite: {
        title: '搜索广告优化',
        type: 'FC_TITLE_REWRITE'
    },
    scriptRewrite: {
        title: '口播文案优化',
        type: 'MOUTH_SCRIPT_REWRITE'
    },
    shortplay: {
        title: '短剧生成',
        type: 'SHORT_PLAY'
    },
    templateText: {
        title: '模板文案生成',
        type: ''
    }
};

export const groupRadiosConfig = [
    {value: 'result', label: '创作结果'}
];

const regexChar = /--|\/\/|%|#|&|~|!|\$|\+|=|@|\[|:|\*|'|\\/;
// eslint-disable-next-line max-len, vue/max-len
const regexWord = /delete|update|alter|create|mid|master|drop|table|and|exec|execute|insert|from|grant|use|order|truncate|or|select|alert|declare|where|sleep|kill|union|dump|connection_id|database|information_schema/;
export function checkInputValid(string) {
    return !regexChar.test(string) && !regexChar.test(regexWord);
}

export function lazyChunkTradesFilter(trades, query) {
    lazyChunkTradesFilter.currentKey = Math.random();
    const run = async runningKey => {
        let res = [];
        if (query.length > 0) {
            const list = chunk(trades, 1000);
            for (let i = 0; i < list.length; i++) {
                const items = list[i];
                if (runningKey !== lazyChunkTradesFilter.currentKey) {
                    break;
                }
                await delay(33);
                const lowerQuery = query.trim().toLowerCase();
                const UpperQuery = query.trim().toUpperCase();
                const matches = items.filter(item => {
                    return item.includes(query) || item.includes(lowerQuery) || item.includes(UpperQuery);
                });
                res = res.concat(matches);
            }
        }
        return res;
    };
    return run(lazyChunkTradesFilter.currentKey);
}

export function formateTrades(children, path = '', result = {list: [], recomFlag: {}}, parentflag) {
    for (const option of children) {
        const {name, children: subOptions, recomFlag} = option;
        const currentPath = path ? `${path} > ${name}` : name;
        result.list.push(currentPath);
        const flag = recomFlag || parentflag;
        if (flag) {
            result.recomFlag[currentPath] = true;
        }
        if (subOptions) {
            formateTrades(subOptions, currentPath, result, flag);
        }
    }
    return result;
}

export function normalizeTrade(trade) {
    if (!trade) {
        return '';
    }
    return trade?.split('>')?.map(x => x.trim())?.join('_');
}

export function reNormalizeTrade(trade) {
    if (!trade) {
        return '';
    }
    return trade?.split('_').join(' > ');
}

// 获取推广业务叶子节点
export function getTradeLeaf(str) {
    if (!str) {
        return '';
    }
    const reNormalizeTradeStr  = reNormalizeTrade(str) || '';
    const arr = (reNormalizeTradeStr.split('>') || []).reverse();
    return arr[0]?.trim();
}

// 数字人编辑器，脚本换行方法
export function wordWrap(value) {
    // 数字人编辑器 脚本文案每行最大字数
    const maxLength = 32;

    try {
        let dealData = value;
        let full = value;

        // 如果没超长，但是粘贴文本里有换行符，那么也是应该换行的
        const replaceCharNewLine = [
            '\\\\r\\\\n', '\\\\n', '\\\\r', '↵',
            '\\\r\\\n', '\\\n', '\\\r',
            '\\r\\n', '\\n', '\\t', '\\r',
            '\r\n', '\n', '\r',
            '<br>', '<br/>'
        ];

        // 如果没超长，则不特殊处理
        if (full.length <= maxLength) {
            // 但是如果粘贴文本里就有换行符的话
            replaceCharNewLine.forEach(char => {
                let reg = new RegExp(char, 'g');
                full = full.replace(reg, '\n');
            });
            let list = full.split('\n').filter(str => str !== '' && str != null);
            // if (list.length === 1) {
            //     this.value = full;
            // } else {
            //     console.log(111, list);
            //     return list;
            //     // this.$emit('paste', index, list);
            // }
            return list;
        }

        // 先处理数据：将所有需要换行的符号都换成句号，然后按句号拆分多行
        // 符号：句号、换行符、逗号、分号、冒号、引号、省略号、感叹号
        let replaceChar = [
            '，', '；', '。', '“', '”', '：', '！',
            ',', '"', ':', '？', '\\?', '!',
            '……', '…', '。。。'
        ].concat(replaceCharNewLine);
        replaceChar.forEach(char => {
            let reg = new RegExp(char, 'g');
            dealData = dealData.replace(reg, '。');
        });

        let pasteSplitArr = dealData.split('。').filter(str => str !== '' && str != null);
        let list = [];

        let length = pasteSplitArr.length;
        for (let index = 0; index < length; index++) {
            let str = pasteSplitArr[index];
            // 是否为空
            if (str == null || str === '') {
                continue;
            }
            // 是否超长，超长，截断，拆分多行
            if (str.length > maxLength) {
                let splitNum = Math.ceil(str.length / maxLength);
                for (let i = 0; i < splitNum; i++) {
                    let start = i * maxLength;
                    list.push(str.substr(start, maxLength));
                }
            }
            else {
                list.push(str);
            }
        }
        return list;
        // 处理完，同步上层
        // this.$emit('paste', index, list);
    }
    catch (e) {
        // console.log(e);
    }
}

export function getVideoScript(value) {
    const COMMON_INPUT_DATA = {
        type: 'TEXT',
        content: ''
    };
    let list = wordWrap(value);
    let scriptList = list.map(str => {
        let resource = {...COMMON_INPUT_DATA};
        resource.content = str;
        return {resource};
    });
    return scriptList;
}

export const urlType = [
    {
        label: '官网',
        value: 1
    }, {
        label: '广告落地页',
        value: 2
    },
    {
        label: '电商商品页',
        value: 3
    }
];
export const feedbackReasonConfig = {
    feedbackReasonList: [{
        label: '文案缺乏卖点',
        value: 'BUSINESS_POINT_INACCURATE'
    }, {
        label: '语义不通畅',
        value: 'SEMANTICS_NOT_COHERENT'
    }, {
        label: '业务识别点不准确',
        value: 'LACKS_SELLING_POINTS'
    }, {
        label: '其他',
        value: 'OTHER'
    }],
    reason: {
        label: '对生成结果不满意？欢迎提出反馈和建议'
    },
    customReason: {
        label: '其他您想留下的建议',
        placeholder: '请输入',
        maxlength: 30,
        rows: 3
    }
};

export const tagInputRules = [
    {
        name: 'maxcount',
        triggers: 'change',
        message: '卖点已达到上限',
        validate(val) {
            return val.length <= 3;
        }
    },
    {
        name: 'maxlength',
        triggers: 'change',
        message: '每个卖点不能超过15个字',
        validate(val) {
            return val.every(item => item.length <= 15);
        }
    },
    {
        name: 'repeat',
        triggers: 'change',
        message: '卖点重复',
        validate(val) {
            return new Set(val).size === val.length;
        }
    },
    {
        name: 'char',
        triggers: 'change',
        message: '违规字符',
        validate(val) {
            return val.every(checkInputValid);
        }
    }
];

export function originRules(formConfig) {
    const {maxlength, minlength} = formConfig.originText;
    return [
        {
            name: 'originText',
            triggers: 'blur,input',
            message: '最多输入5条',
            validate(val) {
                const scripts = val?.split('\n') || [];
                return scripts.length <= 5;
            }
        },
        {
            name: 'length',
            triggers: 'blur',
            message: `每条限制为${minlength}-${maxlength}个字符`,
            validate(val) {
                if (!val) {
                    return true;
                }
                const scripts = val?.split('\n') || [];
                return scripts.every(item => {
                    const charLength = getCharLength(item);
                    return charLength <= maxlength && charLength >= minlength;
                });
            }
        }
    ];
}

export function originScriptRules(formConfig) {
        const {maxlength} = formConfig.originText;
        return [
        {
            name: 'originText',
            value: maxlength,
            triggers: 'blur,input',
            message: '最多可输入1000个字',
            validate(val) {
                if (!val) {
                    return true;
                }
                return val.length <= maxlength;
            }
        }
    ];
}
export const createFcFormData = () => {
    return {
        businessPoint: '',
        keyWord: '',
        salePoints: [],
        description: '',
        originText: '',
        scripts: [],
        effectTarget: 'CLICK',
        brand: '',
        style: '',
        exampleId: 0,
        additionalInfo: '',
        targetCount: '5',
        openDesc: false
    };
};

export const createFeedFormData = () => {
    return {
        businessPoint: '',
        salePoints: [],
        brand: '',
        description: '',
        style: '',
        exampleId: 0,
        effectTarget: 'CLICK',
        originText: '',
        scripts: [],
        targetUserId: 0,
        targetCount: '5',
        targetUser: {},
        additionalInfo: ''
    };
};

export const createScriptFormData = () => {
    return {
        businessPoint: '',
        salePoints: [],
        brand: '',
        effectTarget: 'CLICK',
        duration: null,
        description: '',
        originText: '',
        targetUserId: 0,
        targetUser: {},
        style: '',
        exampleId: 0,
        additionalInfo: '',
        targetCount: '1'
    };
};

export const createShortplayFormData = () => {
    return {
        businessPoint: '',
        description: '',
        roleDesc: '',
        additionalInfo: '',
        duration: 180,
        targetCount: '3'
    };
};



export const showFeedList = [
    'businessPoint',
    'salePoints',
    'brand',
    'description',
    'style',
    'originText',
    'targetUser',
    'additionalInfo',
    // 'effectTarget',
    'duration',
    'targetCount'
];
export const showFcList = [
    'businessPoint',
    'keyWord',
    'salePoints',
    'description',
    'originText',
    'brand',
    'style',
    'additionalInfo'
];

export const showScriptList = [
    'businessPoint',
    'salePoints',
    'brand',
    'description',
    'duration',
    'style',
    'targetUser',
    'originText',
    'additionalInfo',
    // 'effectTarget',
    'targetCount'
];

export const showShortplayList = [
    'businessPoint',
    'description',
    'additionalInfo',
    'roleDesc',
    'duration',
    'targetCount'
];

export const mediaAnalysisConfig = {
    label: '音视频解析',
    inspirationText: '已为您参考灵感素材脚本风格文案',
    inspirationClearTextBefore: '您可以',
    inspirationClearText: '清空当前脚本',
    inspirationClearTextAfter: '，输入自定义脚本文案'
};

export const videoTypeMapping = {
    myVideoSnippet: 1, // 我的视频片段
    copyrightVideoSnippet: 2, // 版权片段
    myvideo: 3, // 我的视频
    recommand: 4 // 推荐视频
};

// 文案是否保存到文案库
export const UNSAVE = 0;
export const SAVED = 1;

export const contentTypeTabBtns = [
    {
        value: 'fc',
        label: '搜索'
    },
    {
        value: 'feed',
        label: '信息流'
    }
];

export const generateWayTabBtns = [
    {
        value: 'PROMPT',
        label: '自由输入'
    },
    {
        value: '',
        label: '结构化输入'
    }
];

export const promptEditConfig = [
    {
        type: 'text',
        content: '我想生成'
    },
    {
        type: 'editLabel',
        labelKey: 'generateType',
        content: '搜索广告',
        showBorder: true,
        editIndex: 0
    },
    {
        type: 'text',
        content: '的文案撰写'
    },
    {
        type: 'br',
        content: ''
    },
    {
        type: 'text',
        content: '根据以下品类：'
    },
    {
        type: 'editLabel',
        labelKey: 'business',
        content: '业务/品类名称',
        showBorder: true,
        editIndex: 1
    },
    {
        type: 'text',
        content: '，每个生成'
    },
    {
        type: 'editLabel',
        labelKey: 'count',
        content: '5',
        editIndex: 2
    },
    {
        type: 'text',
        content: '组创意'
    },
    // {
    //     type: 'text',
    //     content: '，1组创意需要包含1个标题和1个描述',
    //     labelKey: 'keyword_text'
    // },
    {
        type: 'text',
        content: '，创意内容的关键词包含',
        labelKey: 'keyword_text'
    },
    {
        type: 'editLabel',
        content: '关键词',
        labelKey: 'keyword',
        showBorder: true,
        editIndex: 3
    },
    {
        type: 'br',
        content: ''
    },
    {
        type: 'text',
        content: '卖点包含'
    },
    {
        type: 'editLabel',
        content: '卖点1',
        labelKey: 'salePoint1',
        showBorder: true,
        editIndex: 4
    },
    {
        type: 'text',
        content: '、',
        labelKey: 'salePoint1_text'
    },
    {
        type: 'editLabel',
        content: '卖点2',
        labelKey: 'salePoint2',
        showBorder: true,
        editIndex: 5
    },
    {
        type: 'text',
        content: '、',
        labelKey: 'salePoint2_text'
    },
    {
        type: 'editLabel',
        content: '卖点3',
        labelKey: 'salePoint3',
        showBorder: true,
        editIndex: 6
    },
    {
        type: 'br',
        content: ''
    },
    {
        type: 'text',
        content: '品牌名为'
    },
    {
        type: 'editLabel',
        content: '品牌名',
        labelKey: 'brand',
        showBorder: true,
        editIndex: 7
    },
    {
        type: 'br',
        content: ''
    },
    {
        type: 'text',
        content: '示例如下：'
    },
    {
        type: 'br',
        content: ''
    },
    {
        type: 'text',
        content: '标题：'
    },
    {
        type: 'editLabel',
        content: '{{购物}}-京东JD.COM-正品商城,优质商品网上商城',
        labelKey: 'title',
        editIndex: 8
    },
    {
        type: 'br',
        content: ''
    },
    {
        type: 'text',
        content: '描述：',
        labelKey: 'titleDesc_text'
    },
    {
        type: 'editLabel',
        content: '{{购物}}-京东官网,好物低价京东"GO"实惠,刷新超低折扣价,就等你来!',
        labelKey: 'titleDesc',
        editIndex: 9
    },
    {
        type: 'br',
        content: ''
    },
    {
        type: 'text',
        content: '不得包含以下文字：'
    },
    {
        type: 'editLabel',
        content: '文字类型1',
        labelKey: 'exclude1',
        showBorder: true,
        editIndex: 10
    },
    {
        type: 'text',
        content: '、',
        labelKey: 'exclude1_text'
    },
    {
        type: 'editLabel',
        content: '文字类型2',
        labelKey: 'exclude2',
        showBorder: true,
        editIndex: 11
    },
    {
        type: 'text',
        content: '、',
        labelKey: 'exclude2_text'
    },
    {
        type: 'editLabel',
        content: '文字类型3',
        labelKey: 'exclude3',
        showBorder: true,
        editIndex: 12
    },
    {
        type: 'br',
        content: ''
    }
];

export const recommendPrompt = {
    fc: {
        generateType: '搜索广告',
        businessPoint: '智能音箱',
        keyWords: ['购物'],
        salePoints: ['操作方便', '识音率高', '质量保证'],
        brand: '好音箱',
        title: '{购物}-好音箱-正品智能音箱,操作方便,识音率高',
        titleDesc: '{购物}-好音箱官网,音箱刷新超低折扣价,就等你来!',
        excludes: ['包邮', '价保', '爆款直降']
    },
    feed: {
        generateType: '信息流广告',
        businessPoint: '智能音箱',
        salePoints: ['操作方便', '识音率高', '质量保证'],
        brand: '好音箱',
        title: '智能音箱,1折抢,底价冲量,只限今天!',
        excludes: ['包邮', '价保', '爆款直降']
    },
    default: {
        generateType: '搜索广告',
        businessPoint: '业务/品类名称',
        keyWords: ['关键词'],
        salePoints: ['卖点1', '卖点2', '卖点3'],
        brand: '品牌',
        title: '{{购物}}-京东JD.COM-正品商城,优质商品网上商城',
        titleDesc: '{{购物}}-京东官网,好物低价京东"GO"实惠,刷新超低折扣价,就等你来!',
        excludes: ['文字类型1', '文字类型2', '文字类型3']
    }
};

export const promptMaxlength = 5000;